"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _helpers = require("../../../helpers");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionBar = _styledComponents.default.div.withConfig({
  displayName: "ActionBar",
  componentId: "sc-1qg4pub-0"
})(["position:relative;padding:", " 0;display:flex;flex-direction:column;justify-content:flex-start;align-items:flex-start;margin-top:-", ";margin-bottom:", ";a{svg{margin-right:", ";height:1.5rem;width:1.5rem;vertical-align:bottom;}}& > *{position:relative;&:not(:last-child){margin:0 0 ", ";}}@media ", "{min-height:3.5rem;margin-top:-", ";margin-bottom:", ";flex-direction:row;align-items:center;& > *{position:relative;&:not(:last-child){margin:0 ", " 0 0;}}}&::before{content:'';display:block;position:absolute;border-top:1.4px solid ", ";border-bottom:1.4px solid ", ";background:", ";top:0;bottom:0;z-index:0;width:100vw;left:50%;transform:translateX(-50%);}"], (0, _helpers.getSpacing)('small'), (0, _helpers.getSpacing)('medium'), (0, _helpers.getSpacing)('medium'), (0, _helpers.getSpacing)('small'), (0, _helpers.getSpacing)('small'), (0, _helpers.breakpoint)('minTablet'), (0, _helpers.getSpacing)('large'), (0, _helpers.getSpacing)('large'), (0, _helpers.getSpacing)('medium'), (0, _helpers.color)('dark-3'), (0, _helpers.color)('dark-3'), (0, _helpers.color)('white'));

var _default = ActionBar;
exports.default = _default;